import React from 'react';
import { Fade } from 'react-reveal';

function About() {

  const tours = [
    {
      id: 1,
      image: '/Assets/elephants.webp',
      subTitle: 'Discover The Wild',
      location: "Kenya", price: "1935.00"
    },
    {
      id: 2,
      image: '/Assets/giza.webp',
      subTitle: 'The Majestic Pyramid of Giza',
      location: "Egypt", price: "1895.00"
    },
    {
      id: 3,
      image: '/Assets/cape.webp',
      subTitle: 'Sunny Ari Atoll',
      location: "South Africa", price: "1550.00"
    },
    {
      id: 4,
      image: '/Assets/Istanbul.webp',
      subTitle: 'The Historical Istanbul',
      location: "Istanbul", price: '1290.00'
    }
  ]

  return (
    <div className='about-cont'>
      <div className="tour">
        <div className="text">
        <Fade left>
          <p>OUR MOST</p>
          <p>POPULAR TOURS</p> </Fade>
        </div>

        <div className="wrapper">
          {tours.map(tour => {
            return (
              <Fade right>
              <div className="cards" style={{ backgroundImage: `url(${tour.image})` }}>
                <div className="content">
                  <h2>{tour.location}</h2>
                  <p>{tour.subTitle}</p>
                  <p>$ {tour.price}</p>
                </div>
              </div>
              </Fade>
            )
          })}
        </div>
      </div>

          <main className="about-main">
              <div>
          <Fade left>
                <img src="/Assets/swim.webp" alt="sea, luxury homes, beach, swimming pool, architecture, Maldives" /></Fade>
                  <div>
                <Fade right>
                <h1>ABOUT US</h1>
                <h2>WHO WE ARE?</h2>
                <p>At Explore Era, we are a community of avid travelers, adventurers, and storytellers who share a common passion for exploring the world. Our journey began with a simple idea: to create a platform where the spirit of discovery and the love for travel could thrive. What sets us apart is our unwavering commitment to uncovering the hidden gems, embracing diverse cultures, and connecting with people from all walks of life.</p>
                </Fade>
                </div>
              </div>

            <div>
              <div> <Fade left>
              <img src="/Assets/vision.webp" alt="babes, beaches, bikini, brunettes, catrin, claeso, clouds, fashion" /> </Fade>
              </div>
              <div>

              <Fade right>
              <h2>OUR VISION</h2>
              <p>Our vision at Explore Era is to inspire and empower every traveler to embark on their dream adventures. We envision a world where travel transcends beyond mere sightseeing, where it becomes a transformative experience that enriches lives, broadens horizons, and fosters a deep appreciation for the beauty and diversity of our planet. Our goal is to be your trusted companion in this exciting journey, providing you with the tools, knowledge, and inspiration to make each trip unforgettable.</p> </Fade>
              </div>
            </div>

          </main>

    </div>
  )
}

export default About;